import {useEffect, useState} from "react"
import {Copy} from "react-feather";
import UseCopyToClipboard from "../../hooks/UseCopyToClipboard";

const Text = (props) => {

    const {
        name, value, size, label, className, error, required, copy,
        counter, suffix, isReady, controlled = false, onChange, ...rest
    } = props

    const [inputValue, setInputValue] = useState(value ?? '')

    const handleCopy = () => {
        UseCopyToClipboard(controlled ? value : inputValue)
    }

    const handleChange = (ev) => {
        ev.preventDefault()
        if (controlled) {
            onChange?.(ev)
        } else {
            setInputValue(ev.target.value)
            onChange?.(ev)
        }
    }

    useEffect(() => {
        if (!controlled && value !== undefined) {
            setInputValue(value)
        }
    }, [value, controlled])

    return (
        <div className={`form-group${className ? ' '+className : ''}`}>
            {label && <label>
                {required && <span className="text-red required">* </span>} {label}
                {error && <span className="error">{error}</span>}
            </label>}
            <div className="input-container">
                <input
                    type="text"
                    name={name}
                    spellCheck={false}
                    value={controlled ? value ?? '' : inputValue}
                    disabled={!isReady}
                    onChange={handleChange}
                    className={`form-control ${!isReady ? 'is-loading' : ''} form-control-${size ? size : 'sm'} ${className ? className : ''}`}
                    {...rest}
                />

                {counter && <span className="btn-addon">{(controlled ? value : inputValue)?.length ?? 0}</span>}
                {copy && <span className="btn-addon copy" onClick={handleCopy}><Copy/></span>}
                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Text
